// External packages
import * as React from 'react';

// Components
import { Button } from 'components/Button';
import { Card } from 'components/Card';
import { Icon } from 'components/Icons';

// Modules
import { CreateLicenseModal } from 'modules/ulaznice/CreateLicenseModal';
import { LicensesTable } from 'modules/ulaznice/LicensesTable';

export default function LicensesPage() {
	const [modalOpen, setModalOpen] = React.useState(false);

	return (
		<Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
			<div className="flex items-center justify-between gap-x-8 gap-y-4">
				<h1 className="text-2xl text-gray-600">Ulaznice</h1>
				<CreateLicenseModal
					isOpen={modalOpen}
					onOpenChange={setModalOpen}
					modalTrigger={
						<Button icon={<Icon name="plus" />}>Dodaj ulaznicu</Button>
					}
				/>
			</div>
			<hr className="my-6 h-px text-gray-200" />
			<LicensesTable />
		</Card>
	);
}
